// components/TrainingIdSelector.jsx
import React, { useEffect } from "react";
import CustomDropdown from "reusableComponents/booking/shared/CustomDropdown";
import styles from "./styles.module.scss";

const TrainingIdSelector = ({ trainings, trainingId, onSelect, t }) => {
  useEffect(() => {
    if (trainings?.length > 0 && !trainingId) {
      onSelect(trainings[0].id);
    }
  }, [trainings, trainingId, onSelect]);

  if (!trainings || trainings.length === 0) return null;

  const options = trainings.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return (
    <div className={styles.trainingSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.title}>
          {t("booking.step2.training_code")}
        </h2>
      </div>
      <div className={styles.trainingWrapper}>
        <CustomDropdown
          options={options}
          value={trainingId}
          onChange={onSelect}
          placeholder={t("booking.step2.training_code") || "Select training"}
          small={false}
        />
      </div>
    </div>
  );
};

export default TrainingIdSelector;